const cardClasses = {
  product: {
    cardBackground: 'coupon-card',
    entryBackground: 'coupon-entry',
  },
  shop: {
    cardBackground: 'coupon-card',
    entryBackground: 'coupon-entry',
  },
  cross_shop: {
    cardBackground: 'coupon-card platform-coupon-card',
    entryBackground: 'coupon-entry platform-coupon-entry',
  },
};

export function getCardClassName(type = 'shop') {
  return cardClasses[type];
}
